module.exports = __webpack_public_path__ + "static/media/logo_landing.1735fac7.png";